import { Button, ListItem } from "@mui/material"
import { EditableText } from "../EditableText"
import { X } from "@phosphor-icons/react"

interface VectorMetadataItemProps {
	name: string
	value: string
	onMetadataDelete?: (labelName: string) => void
}

function VectorMetadataItem({ name, value, onMetadataDelete }: VectorMetadataItemProps) {
	const displayLabelName = name.split('_').join(' ')

	return (
		<ListItem
			sx={{
				width: 'auto',
				height: '100%',
				display: 'flex',
				alignItems: 'center',
				gap: '0.25rem',

				paddingInline: '0.5rem',
				paddingBlock: '0.25rem',

				borderWidth: '1px',
				borderStyle: 'solid',
				borderColor: '#d4d4d4',
				borderRadius: '9999vmax',

				fontSize: '0.825rem',

				'&:hover > button': {
					display: 'inline-block'
				}
			}}
		>
			<EditableText value={displayLabelName} style={{ height: '1rem' }} />

			<span>:</span>

			<EditableText value={value} style={{ height: '1rem' }} />

			{onMetadataDelete ? (
				<Button
					variant="text"
					onClick={() => onMetadataDelete(name)}
					sx={{
						width: 'auto',
						minWidth: '0.75rem',
						paddingInline: '0.125rem',
						paddingBlock: '0',
						transition: 'all 200ms ease-in',

						display: 'none'
					}}
				>
					<X size={10} />
				</Button>
			) : null}
		</ListItem>
	)
}

export { VectorMetadataItem }